/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TPNProgressBar_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PointsSummary_viewer$ref: FragmentReference;
export type PointsSummary_viewer = {|
  +$fragmentRefs: TPNProgressBar_viewer$ref,
  +$refType: PointsSummary_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PointsSummary_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TPNProgressBar_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bd7825f329f0db07db9febd92310fa1a';
module.exports = node;
